import React from "react";
import { Provider } from "react-redux";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../../utils/createReduxStore";
import { DelayedJobsModule } from "./DelayedJobs";
import reducer from "./redux/delayedJobsReducer";
import rootSaga from "./redux/delayedJobsSagas";

type DelayedJobsProps = {
  notifications?: {
    rollbar?: string;
    env?: string;
  };
};

const DelayedJobs = ({ notifications = {} }: DelayedJobsProps) => {
  return (
    <Provider store={createReduxStore(reducer, "delayedJobs", rootSaga)}>
      <ErrorBoundary moduleName="delayedJobs" {...notifications}>
        <DelayedJobsModule />
      </ErrorBoundary>
    </Provider>
  );
};

export default DelayedJobs;
